import gql from 'graphql-tag';

const Query = {
  intermediaryBusinessConfig: gql`
    query intermediaryBusinessConfig($contactsInfoId: Int!, $date: DateTime) {
      intermediaryBusinessConfig(contactsInfoId: $contactsInfoId, date: $date) {
        id
      }
    }
  `,
  intermediaryBusinessConfigActivationAuto: gql`
    query intermediaryBusinessConfig($contactsInfoId: Int!, $date: DateTime) {
      intermediaryBusinessConfig(contactsInfoId: $contactsInfoId, date: $date) {
        id
        dateEnd
        acceptedTermsConditions
      }
    }
  `,
  findIntermediaryBusinesses: gql`
    query findIntermediaryBusinesses($contactsInfoId: Int!) {
      findIntermediaryBusinesses(contactsInfoId: $contactsInfoId) {
        id
        name
        firstname
        type
        email
        phone
      }
    }
  `,
  getIntermediaryBusinessResume: gql`
    query getIntermediaryBusinessResume($intermediaryBusinessesAssocId: Int!) {
      getIntermediaryBusinessResume(intermediaryBusinessesAssocId: $intermediaryBusinessesAssocId) {
        id
        createdAt
        updatedAt
        intermediaryBusiness {
          id
          matricule
          name
          firstname
          type
          email
          phone
        }
        opportunity {
          property {
            propertiesType {
              name
            }
            city
            zipcode
            street_number
            address
            address_bis
          }
          owners {
            civility
            name
            phone
          }
        }
        accepted
      }
    }
  `,
};

const Mutation = {
  intermediaryBusinessAddConfig: gql`
    mutation intermediaryBusinessAddConfig($contactsInfoId: Int!) {
      intermediaryBusinessAddConfig(contactsInfoId: $contactsInfoId) {
        id
      }
    }
  `,
  intermediaryBusinessAcceptInitialConfig: gql`
    mutation intermediaryBusinessAcceptInitialConfig($contactsInfoId: Int!) {
      intermediaryBusinessAcceptInitialConfig(contactsInfoId: $contactsInfoId)
    }
  `,
  intermediaryBusinessCloseConfig: gql`
    mutation intermediaryBusinessCloseConfig(
      $contactsInfoId: Int!
      $acceptedTermsConditions: IntermediaryBusinessConfigATC
    ) {
      intermediaryBusinessCloseConfig(
        contactsInfoId: $contactsInfoId
        acceptedTermsConditions: $acceptedTermsConditions
      )
    }
  `,
  intermediaryBusinessValidate: gql`
    mutation intermediaryBusinessValidate($id: Int!, $isAccepted: Boolean!) {
      intermediaryBusinessValidate(id: $id, isAccepted: $isAccepted)
    }
  `,
  intermediaryBusinessInvitationSendMail: gql`
    mutation intermediaryBusinessInvitationSendMail($intermediaryBusinessesId: Int!) {
      intermediaryBusinessInvitationSendMail(intermediaryBusinessesId: $intermediaryBusinessesId)
    }
  `,
  intermediaryBusinessInvitationSendSms: gql`
    mutation intermediaryBusinessInvitationSendSms($intermediaryBusinessesId: Int!) {
      intermediaryBusinessInvitationSendSms(intermediaryBusinessesId: $intermediaryBusinessesId)
    }
  `,
  intermediaryBusinessAdd: gql`
    mutation intermediaryBusinessAdd($contactsInfoId: Int!, $params: IntermediaryBusinessInput) {
      intermediaryBusinessAdd(contactsInfoId: $contactsInfoId, params: $params) {
        id
      }
    }
  `,
  intermediaryBusinessDelete: gql`
    mutation intermediaryBusinessDelete($id: Int!) {
      intermediaryBusinessDelete(id: $id)
    }
  `,
  intermediaryBusinessUpdate: gql`
    mutation intermediaryBusinessUpdate($id: Int!, $params: IntermediaryBusinessInput) {
      intermediaryBusinessUpdate(id: $id, params: $params)
    }
  `,
};

export default {
  Query,
  Mutation,
};
